import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Row, Col, Spin } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import FilterTitle from '../title'

export const IconWrapper = styled.div`
  background: ${props => props.theme.colors.color2.bg};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledSVG = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.light4};
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;
  &.activ {
    color: ${props => props.theme.colors.color1.bg};
    ${IconWrapper} {
      background: ${props => props.theme.colors.color1.bg};
    }
  }
`

const Energy = props => {
  const { intl, loading, onChangeFilter, filters, filtersDatas } = props

  const { fuels } = filters
  const fuelsList = filtersDatas.fuels

  const handleClick = item => {
    const isSelected = !fuels ? false : fuels.filter(el => el === item.id).length > 0

    let extendedEnergiesValues = fuels ? [...fuels] : []

    if (!isSelected) {
      extendedEnergiesValues.push(item.id)
    } else {
      extendedEnergiesValues = fuels.filter(el => el !== item.id)
    }

    const extendedFiltersValues = {
      ...filters,
      fuels: extendedEnergiesValues
    }
    onChangeFilter(extendedFiltersValues)
  }

  const renderIcon = id => {
    let icon

    switch (id) {
      case 1:
        icon = svg.energies.gasoline
        break
      case '00100003':
        icon = svg.energies.diesel
        break
      case 3:
        icon = svg.energies.hybrid
        break
      case 4:
        icon = svg.energies.GPL
        break
      case '00100004':
        icon = svg.energies.electric
        break
      default:
        break
    }

    return icon ? (
      <IconWrapper>
        <StyledSVG svg={icon} data-test="stock-vehicles-list-filters-energy-FilterItemIcon" />
      </IconWrapper>
    ) : null
  }

  const renderItem = item => {
    const { wording, id } = item

    const isSelected = !fuels ? false : fuels.filter(el => el === item.id).length > 0

    return (
      <FilterItemWrapper
        key={id}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        span={12}
        data-test="stock-vehicles-list-filters-energy-FilterItemWrapper"
      >
        <Row type="flex" gutter={10} style={{ alignItems: 'center' }}>
          <Col>{renderIcon(id)}</Col>
          <Col>{wording}</Col>
        </Row>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-energy">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-energy-title'
        })}
        data-test="stock-vehicles-list-filters-energy-title"
      />
      <Row type="flex" justify={loading ? 'center' : 'start'}>
        {loading && <Spin />}
        {!loading && fuelsList && fuelsList.map(item => renderItem(item))}
      </Row>
    </div>
  )
}

Energy.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Energy)
